import { IotGateModel, gateNameConstants } from "@/app/models/iot-gate.model"

const PREFERRED_MAIN_GATE_NAMES = gateNameConstants.filter(name =>
  ["main", "mainInner", "barrierEntry", "barrierInner"].includes(name),
)

/**
 * Finds the most suitable "main" gate from a list of gates.
 * Prefers gates with names matching main entry gate constants,
 * falls back to the gate with the lowest gateId.
 */
export function findMainGate(gates: IotGateModel[]): IotGateModel | undefined {
  if (!gates.length) return undefined
  return (
    gates.find(gate => PREFERRED_MAIN_GATE_NAMES.includes(gate.name)) ??
    [...gates].sort((a, b) => Number(a.gateId) - Number(b.gateId))[0]
  )
}
